module.exports = __webpack_public_path__ + "img/apple_pie_baked_closeup.4be494cb.jpg";